import React, { Fragment } from "react";

import { fundStatusLabel, fundStatusColor } from "../../helpers/fund";

const Result = ({ result }) => {
  if (!result.Fund_Name || !result.permalink) {
    return null;
  }

  return (
    <Fragment>
      {result && (
        <li className="QuickSearch-results-item f-scale-body">
          <a href={result.permalink} className="QuickSearch-results-link">
            {result.Fund_Name}
            <span
              className={`QuickSearch-results-status f-label-small u-mb1 c-${fundStatusColor(
                result
              )}`}
            >
              {fundStatusLabel(result)}
            </span>
          </a>
        </li>
      )}
    </Fragment>
  );
};

export default Result;
